import React, { useEffect, useMemo, useState } from "react";
import ModalBackdrop from "components/ModalBackdrop";
import { DropdownSelect, NumberInput, TextAreaInput, TextInput } from "components/InputStyled";
import { flattenClassificationHierarchy, wouldCreateClassificationCycle } from "../lib/hierarchy";

export default function ClassificationValueModal({ classification, value, saving, onSave, onDelete, onClose }) {
  const [draft, setDraft] = useState({ name: "", code: "", description: "", parent_value_id: "", sort_order: 0, is_active: true });
  useEffect(() => {
    setDraft({ name: "", code: "", description: "", parent_value_id: "", sort_order: 0, is_active: true, ...(value || {}) });
  }, [value]);

  const parentOptions = useMemo(
    () => flattenClassificationHierarchy(classification?.values || [])
      .filter((candidate) => candidate.is_active && candidate.id !== value?.id && !wouldCreateClassificationCycle(classification.values, value?.id, candidate.id))
      .map((candidate) => ({ value: candidate.id, label: `${"— ".repeat(candidate.depth)}${candidate.name}` })),
    [classification, value?.id]
  );

  return (
    <ModalBackdrop onClose={saving ? undefined : onClose}>
      <form className="w-full max-w-xl rounded-xl border border-border bg-app p-6 shadow-xl" onSubmit={(event) => { event.preventDefault(); onSave(draft); }}>
        <h2 className="text-lg font-semibold text-brand">{value?.id ? "Edit Classification Value" : "New Classification Value"}</h2>
        <p className="mt-1 text-sm text-muted">{classification.name}</p>
        <div className="mt-5 grid gap-4 md:grid-cols-2">
          <TextInput label="Name" value={draft.name} onChange={(name) => setDraft((current) => ({ ...current, name }))} className="w-full" required />
          <TextInput label="Code" value={draft.code} onChange={(code) => setDraft((current) => ({ ...current, code }))} className="w-full" />
          <DropdownSelect label="Parent Value" value={draft.parent_value_id || ""} onChange={(parent_value_id) => setDraft((current) => ({ ...current, parent_value_id }))} options={parentOptions} placeholder="Top level" className="w-full" />
          <NumberInput label="Sort Order" value={draft.sort_order} onChange={(sort_order) => setDraft((current) => ({ ...current, sort_order }))} type="integer" className="w-full" />
        </div>
        <div className="mt-4"><TextAreaInput label="Description" value={draft.description} onChange={(description) => setDraft((current) => ({ ...current, description }))} rows={3} /></div>
        <div className="mt-6 flex items-center justify-between gap-2">
          <div>
            {value?.id ? <button type="button" className="btn bg-red-600 text-white hover:bg-red-700" onClick={onDelete} disabled={saving}>Delete Value</button> : null}
          </div>
          <div className="flex gap-2">
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving || !draft.name.trim()}>{saving ? "Saving…" : "Save Value"}</button>
          </div>
        </div>
      </form>
    </ModalBackdrop>
  );
}
